<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card class="pcard pcard--orange">
      <div class="pcard-header">
        <div class="pcard-header-left">
          <div class="pcard-icon-wrap" style="background:rgba(255,255,255,0.18)">
            <v-icon color="white" size="22">mdi-crosshairs-gps</v-icon>
          </div>
          <div>
            <p class="pcard-header-sub" style="color:rgba(255,255,255,0.9)!important">{{ $t('sidebar.live') }}</p>
            <h2 class="pcard-header-title" style="color:#fff!important">{{ $t('sidebar.live_tracking') }}</h2>
          </div>
        </div>
      </div>
      <v-card-text>
        <div class="tracking-div">
          <div class="tracking-map">
            <div class="tile-selector">
              <button v-for="s in tileStyles" :key="s.key" class="tile-btn"
                :class="{ active: tileStyle === s.key }" @click="tileStyle = s.key">{{ s.label }}</button>
            </div>
            <l-map
              style="height: 350px; border-radius: 14px; overflow: hidden;"
              :zoom="zoom"
              :center="center"
              ref="mymap"
            >
              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
              <l-marker
                v-for="(location, index) in busesLocation"
                :key="location.ride.id"
                :lat-lng="ankora(location)"
                :ref="`location-${location.ride.id}`"
              >
                <l-icon :icon-size="busIconSize(busLabel(location))" :icon-anchor="busIconAnchor(busLabel(location))" :icon-url="busIcon(location.ride && location.ride.bus_id, busLabel(location))"></l-icon>
                <l-tooltip>
                  Bus:
                  <span v-if="location.ride.bus">{{ location.ride.bus.name }}</span>
                  <br />
                  <div v-for="student in location.ride.bus.students" :key="student.id">
                    Student: {{ student.name }}<br />
                  </div>
                  Started At:
                  <span v-if="location.ride.started_at">{{ location.ride.started_at | moment('DD/MM/YYYY HH:mm') }}</span>
                  <span v-else>-</span>
                  <br />
                  Finished At:
                  <span v-if="location.ride.finished_at">{{ location.ride.finished_at | moment('DD/MM/YYYY HH:mm') }}</span>
                  <span v-else>-</span>
                </l-tooltip>
              </l-marker>
            </l-map>
            <div class="my-2">
              <div v-for="location in busesLocation" :key="location.ride.id">
                <v-btn dark color="primary" type="button" class="mx-2" @click="goToCenterLocation(location.coordinates)">
                  Center&nbsp;
                  <span v-if="location.ride.bus">{{ location.ride.bus.name }}</span>
                </v-btn>
              </div>
            </div>
          </div>

          <div class="tracking-rides">
            <div style="padding-block: 10px; max-height: 600px" class="scroll">
              <div class="ride-card mb-3" v-for="element in rides" :key="element.id">
                <!-- Bus name row -->
                <div class="ride-card-header">
                  <div class="ride-card-icon ride-icon-orange">
                    <v-icon size="18" color="#e65100">mdi-bus</v-icon>
                  </div>
                  <span class="ride-card-bus-name" v-if="element.ride && element.ride.bus">{{ element.ride.bus.name }}</span>
                  <span class="ride-card-bus-name" v-else>—</span>
                </div>
                <!-- Student row -->
                <div class="ride-card-row" v-if="element.student">
                  <div class="ride-card-icon ride-icon-blue">
                    <v-icon size="16" color="#1976D2">mdi-badge-account-outline</v-icon>
                  </div>
                  <span class="ride-card-text">{{ element.student.name }}</span>
                </div>
                <!-- Start time -->
                <div class="ride-card-row" v-if="element.started_at">
                  <div class="ride-card-icon ride-icon-green">
                    <v-icon size="16" color="#388E3C">mdi-clock-start</v-icon>
                  </div>
                  <span class="ride-card-text ride-card-text--muted">
                    {{ element.started_at | moment('DD/MM/YYYY') }}
                    <strong>{{ element.started_at | moment('HH:mm') }}</strong>
                  </span>
                </div>
                <!-- End time -->
                <div class="ride-card-row" v-if="element.finished_at">
                  <div class="ride-card-icon ride-icon-teal">
                    <v-icon size="16" color="#00838F">mdi-clock-end</v-icon>
                  </div>
                  <span class="ride-card-text ride-card-text--muted">
                    {{ element.finished_at | moment('DD/MM/YYYY') }}
                    <strong>{{ element.finished_at | moment('HH:mm') }}</strong>
                  </span>
                </div>
                <!-- Rejected -->
                <div class="ride-card-row" v-if="element.rejected_at">
                  <div class="ride-card-icon ride-icon-red">
                    <v-icon size="16" color="#D32F2F">mdi-alpha-x-circle-outline</v-icon>
                  </div>
                  <span class="ride-card-text" style="color:#D32F2F">
                    {{ element.rejected_at | moment('DD/MM/YYYY HH:mm') }} — Rejected
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading';
// Levizja e autobusit midis dy pozicioneve, qe te mos kerceje.
import { glideTo } from '@/utils/marker-glide';
import { busIcon, busIconSize, busIconAnchor } from '@/utils/bus-icon';
import { Keys } from '/src/config.js';

export default {
  components: { VueElementLoading, Keys },
  data() {
    return {
      isLoading: false,
      tileStyle: ['satellite', 'standard', 'esri', 'terrain'].includes(localStorage.getItem('mapTileStyle'))
        ? localStorage.getItem('mapTileStyle')
        : 'satellite',
      tileStyles: [
        { key: 'satellite', label: 'Satelit' },
        { key: 'standard',  label: 'Standard' },
        { key: 'esri',      label: 'Esri' },
        { key: 'terrain',   label: 'Terrain' },
      ],
      attribution: '',
      zoom: 12,
      center: [42.6526173, 21.1464795],
      markerLatLng: [42.6526173, 21.1464795],
      bus_id: null,
      rides: [],
      busesLocation: [],
      // Id-te e udhetimeve qe serveri ia lejon ketij nxenesi.
      udhetimetELejuara: [],
      hasFitBounds: false,
      pollInterval: null,
    };
  },
  mounted() {
    // Ankorat e markuesve. Jashte `data` qe te mos jene reaktive.
    this.ankorat = {};

    this.getAllRides();
    this.getLocations();
    this.pollInterval = setInterval(() => { this.getRideBuses() }, 15000);
    this.getRideBuses();
    const map = this.$refs.mymap.mapObject;
    map.addControl(new window.L.Control.Fullscreen());
    map.removeControl(map.attributionControl);
    setTimeout(() => { map.invalidateSize(); }, 200);
  },
  computed: {
    url() {
      const tiles = {
        satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        standard:  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        esri:      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        terrain:   'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
      };
      return tiles[this.tileStyle] || tiles.satellite;
    },
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
  },
  watch: {
    busesLocationVisible: {
      handler(val) {
        if (val.length) {
          this.$nextTick(() => {
            this.$refs.mymap?.mapObject?.invalidateSize();
          });
        }
      },
    },
        tileStyle(val) { localStorage.setItem('mapTileStyle', val); },
  },
  methods: {
    /**
     * Pozicioni me te cilin lidhet shablloni — i pandryshueshem.
     *
     * Kthen gjithmone te njejtin varg per nje udhetim, ndaj vue2-leaflet nuk
     * e prek me markuesin pas krijimit dhe levizjen e zoteron `glideTo`.
     * Dyqani mbahet jashte `data`: po te ishte reaktiv, do te shkaktonte
     * riperpunim ne cdo kornize te animacionit.
     */
    ankora(location) {
      // Shablloni renderohet para `mounted`, ndaj dyqani krijohet ketu nese
      // ende nuk ekziston.
      if (!this.ankorat) this.ankorat = {};

      const id = location && location.ride ? location.ride.id : undefined;
      if (id === undefined) return location ? location.coordinates : undefined;

      if (!this.ankorat[id]) this.ankorat[id] = location.coordinates;
      return this.ankorat[id];
    },
    fitMapToBuses() {
      if (!this.busesLocation.length || this.hasFitBounds) return;
      this.hasFitBounds = true;
      const map = this.$refs.mymap?.mapObject;
      if (!map) return;
      const coords = this.busesLocation.map(l => l.coordinates);
      if (coords.length === 1) {
        map.setView(coords[0], 14);
      } else {
        map.fitBounds(coords, { padding: [50, 50], maxZoom: 14 });
      }
    },
    getAllRides(student_id) {
      axios
        .get('/rides/student', { params: { student_id } })
        .then((response) => { this.rides = response?.data; })
        .catch(() => {
          this.$notify({ title: 'Error', text: 'Error fetching rides', type: 'error' });
        })
        .then(() => { this.isLoading = false; });
    },
    getLocations() {
      window.Echo.private(`bus-location`).listen('.location-updated', (e) => {
        if (!!this.bus_id && this.bus_id !== e.ride?.bus_id) return;

        // Kanali transmeton pozicionin e cdo autobusi ne sistem; lejohen
        // vetem udhetimet qe i kthen serveri per kete nxenes.
        if (!this.udhetimetELejuara.includes(e.ride?.id)) return;

        const newRide = { ...e };
        newRide.coordinates = Object.values(newRide.coordinates);

        const index = this.busesLocation.findIndex((item) => item.ride?.id === newRide.ride?.id);
        if (index !== -1) {
          this.busesLocation[index] = newRide;
        } else {
          this.busesLocation.push(newRide);
        }

        this.busesLocation = this.busesLocation.map((l) => {
          const lat = Number(l.coordinates[0]);
          const lng = Number(l.coordinates[1]);
          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            console.warn('Invalid coords for', l.ride.id, l.coordinates);
            return l;
          }
          return { ...l, coordinates: [lat, lng] };
        });

        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            glideTo(cmp?.mapObject, l.coordinates);
          }
          this.fitMapToBuses();
        });
      });
      window.Echo.private(`bus-location-refresh`).listen('.location-refresh', (e) => {
        this.getRideBuses();
        this.getAllRides(this.bus_id);
      });
    },
    getRideBuses(student_id) {
      axios
        .get('/rides/student/buses', { params: { student_id } })
        .then((response) => {
          const rides = response?.data;
          this.udhetimetELejuara = (rides || []).map((r) => r.id);
          // Nje autobus mund te kete disa udhetime brenda dites. Shenja vendoset
          // ne pozicionin e tanishem te autobusit, ndaj udhetimet e perfunduara
          // do te jepnin disa shenja identike, njera mbi tjetren. Ne harte dalin
          // vetem ato qe jane ende ne rruge; lista majtas i mban te gjitha.
          const neRruge = (rides || []).filter((r) => !r.finished_at);

          this.busesLocation = this.busesLocation.filter((l) => neRruge.some((r) => r.id === l.ride?.id));
          if (neRruge.length > 0) {
            neRruge.map((ride) => {
              const location = {
                ride,
                coordinates: [ride?.bus?.latitude ?? 42.6664358, ride?.bus?.longitude ?? 21.1175278],
              };
              const index = this.busesLocation.findIndex((item) => item?.ride?.id === location?.ride?.id);
              if (index !== -1) {
                this.busesLocation[index] = location;
              } else {
                this.busesLocation.push(location);
              }
            });
          } else {
            this.busesLocation = [];
          }

          this.busesLocation = this.busesLocation.map((l) => {
            const lat = Number(l.coordinates[0]);
            const lng = Number(l.coordinates[1]);
            if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
              console.warn('Invalid coords for', l.ride.id, l.coordinates);
              return l;
            }
            return { ...l, coordinates: [lat, lng] };
          });

          this.$nextTick(() => {
            for (const l of this.busesLocation) {
              const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
              glideTo(cmp?.mapObject, l.coordinates);
            }
          });
        })
        .catch(() => {
          this.$notify({ title: 'Error', text: 'Error fetching buses location', type: 'error' });
        });
    },
    goToCenterLocation(coordinates) {
      this.$nextTick(() => {
        const map = this.$refs.mymap.mapObject;
        map.flyTo(coordinates, 13);
      });
    },
    busIcon,
    busIconSize,
    busIconAnchor,

    /** Numri ose emri i shkurter i autobusit, i shfaqur nen shenje. */
    busLabel(location) {
      const emri = location && location.ride && location.ride.bus && location.ride.bus.name;
      if (!emri) return '';
      // Vetem numri kur emri eshte si "Autobusi 3"; perndryshe tre shkronjat e para.
      const numri = String(emri).match(/\d+/);
      return numri ? numri[0] : String(emri).slice(0, 3);
    },
  },
};
</script>

<style>
.v-application ul { padding-left: 12px !important; }
</style>

<style lang="scss">
.scroll { overflow: scroll; scrollbar-gutter: stable; }

.tracking-div {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
}
.tracking-map { flex: 0 0 65%; }
.tracking-rides { flex: 0 0 35%; }

@media (max-width: 700px) {
  .tracking-div { flex-direction: column; }
  .tracking-map, .tracking-rides { flex: 0 0 100%; }
}

/* Page card header */
.pcard { border-radius: 14px !important; overflow: hidden; border: none !important; }
.pcard-header {
  padding: 18px 20px;
  display: flex; align-items: center; justify-content: space-between;
}
.pcard--orange .pcard-header { background: linear-gradient(135deg, #BF360C, #FF8F00); }
.pcard-header-left { display: flex; align-items: center; gap: 12px; }
.pcard-icon-wrap {
  width: 40px; height: 40px; border-radius: 10px;
  display: flex; align-items: center; justify-content: center;
}
.pcard-header-sub { color: #fff !important;
  font-size: 11px;
  text-transform: uppercase; letter-spacing: 0.5px;
  margin: 0; font-weight: 600; opacity: 0.88;
}

.pcard-bank-info {
  padding: 8px 20px 12px 20px;
  background: rgba(0,0,0,0.12);
  color: #fff !important;
  font-size: 13px;
  display: flex;
  align-items: center;
}
.pcard-header-title { font-size: 18px; font-weight: 800; color: #fff !important; margin: 0; }

/* Ride cards */
.ride-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 32px 16px; text-align: center;
}
.ride-empty-text { color: #94a3b8; font-size: 14px; margin-top: 8px; }
.ride-card {
  background: #fff;
  border: 1px solid rgba(0,0,0,0.07);
  border-radius: 12px;
  padding: 12px 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}
.ride-card-header { display: flex; align-items: center; gap: 10px; margin-bottom: 8px; }
.ride-card-bus-name { font-size: 14px; font-weight: 700; color: #1a2744; }
.ride-card-row { display: flex; align-items: center; gap: 10px; margin-bottom: 6px; }
.ride-card-icon {
  width: 28px; height: 28px; border-radius: 8px;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.ride-icon-orange { background: rgba(230,81,0,0.1); }
.ride-icon-blue   { background: rgba(25,118,210,0.1); }
.ride-icon-green  { background: rgba(56,142,60,0.1); }
.ride-icon-teal   { background: rgba(0,131,143,0.1); }
.ride-icon-red    { background: rgba(211,47,47,0.1); }
.ride-card-text { font-size: 13px; color: #374151; }
.ride-card-text--muted { color: #64748b; }

.tile-selector {
  display: flex;
  gap: 6px;
  margin: 8px 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.tile-selector::-webkit-scrollbar { display: none; }
.tile-btn {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1.5px solid #ccc;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #444;
  white-space: nowrap;
  flex-shrink: 0;
}
.tile-btn:hover { border-color: #F57C00; color: #F57C00; }
.tile-btn.active { background: #F57C00; color: #fff; border-color: #F57C00; }

.tracking-map .leaflet-container { touch-action: none; z-index: 0; isolation: isolate; }
.no-trip-msg { text-align: center; padding: 32px 16px; color: #94a3b8; }
.no-trip-msg p { margin-top: 8px; font-size: 13px; }
.leaflet-control-attribution { display: none !important; }
</style>